import { useTranslations } from 'next-intl';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { GlowModal, GlowTextBody, GlowTitle, PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { InnerHTML } from '../../innerHTML';
import { usePriceRegulationAssets } from '../../productDetails/infos/hooks/usePriceRegulationAssets';

type PriceRegulationModalProps = PropsWithFontFamily & {
    close(id: string, remove?: boolean): void;
    id: string;
};

export const PriceRegulationModal: Component<PriceRegulationModalProps> = ({ close, id, fontFamily }) => {
    const t = useTranslations('Discover.Pdp.information.price');

    const { result: priceRegulationAssetResult } = usePriceRegulationAssets();
    const priceRegulationContent = unwrapResultSuccess(priceRegulationAssetResult)?.content.html;

    const closeModal = () => {
        close(id, true);
    };

    return (
        <GlowModal.Container
            id={'product-detail-regulation-info-modal'}
            title={t('pricesModal.label.secondTitle')}
            onClick={closeModal}
            onClickBackCta={closeModal}
        >
            <GlowModal.Content>
                <GlowTitle text={t('legalMentionsModal.label.subTitle')} fontSize={'title5'} TagName={'h3'} />
                {priceRegulationContent && (
                    <GlowTextBody fontFamily={fontFamily} innerHTML={<InnerHTML rawHtml={priceRegulationContent} />} />
                )}
            </GlowModal.Content>
        </GlowModal.Container>
    );
};
